import type { Step } from "react-joyride";

export const projectDetailTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າລາຍລະອຽດໂຄງການ! ຫນ້ານີ້ສະແດງຂໍ້ມູນໂຄງການ ວຽກຍ່ອຍ ຄວາມສຽງ ແລະ ໄລຍະເວລາ. ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຫນ້ານີ້ໃນບົດສອນສັ້ນໆນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="detail-header"]',
    content:
      "ນີ້ແມ່ນສ່ວນ header. ທ່ານສາມາດແກ້ໄຂໂຄງການ, ເພີ່ມວຽກຍ່ອຍ ຫຼື ລຶບໂຄງການ (ຖ້າມີສິດ) ຈາກປຸ່ມທີ່ນີ້.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="detail-cards"]',
    content:
      "ນີ້ແມ່ນສະຫຼຸບສະຖານະໂຄງການ: ສະຖານະ ວັນເລີ່ມ–ສິ້ນສຸດ, ຄວາມຄືບໜ້າ (%), ຈຳນວນສະມາຊິກທີມ ແລະ ຄວາມສຽງທີ່ເປີດ.",
    placement: "top",
  },
  {
    target: '[data-tourid="detail-tabs"]',
    content:
      "ນີ້ແມ່ນແທັບວຽກຍ່ອຍ, ຄວາມສຽງ ແລະ ໄລຍະເວລາ. ກົດເພື່ອສະແດງລາຍການວຽກຍ່ອຍ ຄວາມສຽງ ຫຼື ກາຟໄລຍະເວລາຂອງໂຄງການ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="detail-open-risks"]',
    content:
      "ນີ້ແມ່ນຄວາມສຽງທີ່ກຳລັງເປີດ. ທ່ານສາມາດເພີ່ມຄວາມສຽງໃໝ່ຈາກປຸ່ມ 'ເພີ່ມຄວາມສຽງ' ຫຼືແກ້ໄຂຄວາມສຽງທີ່ມີຢູ່.",
    placement: "top",
  },
  {
    target: '[data-tourid="detail-next-milestone"]',
    content:
      "ນີ້ແມ່ນຈຸດໝາຍຖັດໄປ. ສະແດງວຽກຍ່ອຍຫຼືຂັ້ນຕອນທີ່ໃກ້ຄຽງທີ່ສຸດ ແລະສາມາດສ້າງວຽກຍ່ອຍໃໝ່ຈາກປຸ່ມດ້ານລຸ່ມ.",
    placement: "top",
  },
];
